
const ServicesOverview = () => {
  const services = [
    {
      title: "Global Strategy & Market Research",
      description: "Comprehensive market analysis and entry strategies tailored to your business goals.",
      features: [
        "Market opportunity assessment",
        "Competitive landscape analysis",
        "Cultural adaptation strategies",
        "Regulatory compliance guidance",
        "Pricing strategy optimization"
      ],
      icon: "ri-global-line",
      color: "bg-blue-500"
    },
    {
      title: "Cross-Border Logistics & Fulfillment",
      description: "End-to-end logistics solutions to get your products to customers worldwide.",
      features: [
        "International shipping setup",
        "Customs documentation",
        "Warehouse partnerships",
        "Returns management",
        "Duty and tax optimization"
      ],
      icon: "ri-truck-line",
      color: "bg-green-500"
    },
    {
      title: "E-Commerce Platform Optimization",
      description: "Technical setup and optimization for international sales across all major platforms.",
      features: [
        "Multi-currency implementation",
        "International payment gateways",
        "Localized checkout flows",
        "SEO for international markets",
        "Performance optimization"
      ],
      icon: "ri-store-line",
      color: "bg-purple-500"
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Three Core Services, One Global Solution
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Our comprehensive approach covers every aspect of international expansion, 
            from initial strategy to ongoing optimization.
          </p>
        </div>

        <div className="grid lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div key={index} className="bg-gray-50 rounded-xl p-8 hover:shadow-lg transition-shadow">
              <div className={`w-16 h-16 ${service.color} rounded-lg flex items-center justify-center mb-6`}>
                <i className={`${service.icon} text-2xl text-white`}></i>
              </div>
              
              <h3 className="text-2xl font-bold text-gray-900 mb-4">{service.title}</h3>
              <p className="text-gray-600 mb-6 leading-relaxed">{service.description}</p>
              
              <ul className="space-y-3">
                {service.features.map((feature, featureIndex) => (
                  <li key={featureIndex} className="flex items-start">
                    <i className="ri-check-line text-teal-600 mt-1 mr-3 flex-shrink-0"></i>
                    <span className="text-gray-700">{feature}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesOverview;
